import { useState } from "react";
import { Tabs, Input, Select, Button, Tag } from "antd";

const { TabPane } = Tabs;

const MappingTabs = ({
  mappings,
  setMappings,
  inputColsData,
  mapObject,
  setMappingsData,
}) => {
  const [activeTab, setActiveTab] = useState("0"); // Track active tab
  const [newCurrency, setNewCurrency] = useState("");

  const handleChange = (index, field, value) => {
    setMappings((prevMappings) => {
      const newMappings = [...prevMappings];
      if (field.includes("secondary.")) {
        const subField = field.split(".")[1];
        newMappings[index].secondary[subField] = value;
      } else {
        newMappings[index][field] = value;
      }
      return [...newMappings];
    });
  };

  const addMapping = () => {
    setMappings([
      ...mappings,
      {
        key: "",
        description: "",
        account: "",
        secondary: { description: "", account: "" },
      },
    ]);
    setActiveTab(String(mappings.length)); // Switch to new tab
  };

  const removeMapping = (index) => {
    const newMappings = mappings.filter((_, i) => i !== index);
    setMappings(newMappings);
    setActiveTab("0"); // Reset active tab
  };

  // Function to add new currency
  const addCurrency = () => {
    if (
      newCurrency &&
      !mapObject.currency.includes(newCurrency.toUpperCase())
    ) {
      setMappingsData((prev) => ({
        ...prev,
        currency: [...prev.currency, newCurrency.toUpperCase()],
      }));
    }
    setNewCurrency(""); // Clear input after adding
  };

  // Function to remove a currency
  const removeCurrency = (currency) => {
    setMappingsData((prev) => ({
      ...prev,
      currency: prev.currency.filter((cur) => cur !== currency),
    }));
  };

  return (
    <div className="p-2">
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        type="editable-card"
        onEdit={(key, action) =>
          action === "add" ? addMapping() : removeMapping(parseInt(key))
        }
      >
        {mappings.map((mapping, index) => (
          <TabPane tab={`Combination ${index + 1}`} key={String(index)}>
            <div className="flex flex-col gap-2 border p-4 rounded-lg mb-2">
              <Input
                placeholder="Enter Key"
                value={mapping.key}
                onChange={(e) => handleChange(index, "key", e.target.value)}
              />

              <Select
                allowClear
                name="description"
                placeholder="Select Input Description"
                value={mapping.description || undefined}
                options={inputColsData.map((item) => ({
                  label: item.inColChr,
                  value: item.inColChr,
                }))}
                onChange={(value) => handleChange(index, "description", value)}
              />

              <Input
                placeholder="Enter Account"
                value={mapping.account}
                onChange={(e) => handleChange(index, "account", e.target.value)}
              />

              <h4 className="font-bold mt-2">Balance with debit/credit</h4>
              <Input
                placeholder="Enter Description Entry for Balancing Account "
                value={mapping.secondary.description}
                onChange={(e) =>
                  handleChange(index, "secondary.description", e.target.value)
                }
              />
              <Input
                placeholder="Enter Account Entry for Balancing Account"
                value={mapping.secondary.account}
                onChange={(e) =>
                  handleChange(index, "secondary.account", e.target.value)
                }
              />

              {/* <Button onClick={() => removeMapping(index)} danger>
                Remove
              </Button> */}
            </div>
          </TabPane>
        ))}
      </Tabs>
      <div className="py-4">
        <div className="flex space-x-2">
          <Input
            placeholder="Enter Currency (e.g., USD)"
            value={newCurrency}
            onChange={(e) => setNewCurrency(e.target.value)}
          />
          <Button type="primary" onClick={addCurrency}>
            Add Currency
          </Button>
        </div>

        <h3 className="mt-4 font-bold">Added Currencies:</h3>
        <div className="flex gap-2 flex-wrap">
          {mapObject?.currency.map((cur) => (
            <Tag
              key={cur}
              closable
              onClose={() => removeCurrency(cur)}
              color="blue"
            >
              {cur}
            </Tag>
          ))}
        </div>

        {/*
        <h3 className="mt-6 font-bold">Current Data Object:</h3>
         <pre className="bg-gray-100 p-4">
          {JSON.stringify(mapObject, null, 2)}
        </pre> */}
      </div>

      {/* <Button type="dashed" onClick={addMapping}>
        + Add Mapping
      </Button> */}
    </div>
  );
};

export default MappingTabs;
